'use strict';

angular.module('utils').factory('OCStringUtil', function() {
  return {
    slugify: function(str) {
      if (!str) {
        return str;
      }
      return str.toLowerCase().trim()
        .replace(/[^a-z-\s]+/g, '')
        .replace(/\s+/g, '-')
        .replace(/[-]{2,}/g, '-')
        .replace(/^[-]+/, '')
        .replace(/[-]+$/, '');
    },

    toBool: function(str) {
      return str && (/(true|t|yes|y|1)/).test(str);
    },

    isUnitedStates: function(country) {
      return !!(country && (/^(United States|United States of America|America|US|USA)$/i).test(country));
    },

    isCanada: function(country) {
      return !!(country && (/^(Canada|Can|CA|Kanada)$/i).test(country));
    },
  };
});
